import App from './App';
import './i18n';
import 'config/config';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@app/store/store';
import { BrowserRouter } from 'react-router-dom';

import { VariantContext, variants, UiVariant } from './variant';

const root = createRoot(document.getElementById('root')!);

async function resolveVariantAndBase() {
  const qp = new URLSearchParams(location.search).get('variant');
  if (qp === 'control' || qp === 'user') {
    return { variant: variants[qp], basename: '/' };   // query ⇒ base "/"
  }

  const host = location.hostname.toLowerCase();
  if (host.startsWith('control.') || host.includes('.control.')) {
    return { variant: variants.control, basename: '/' }; // subdomain ⇒ base "/"
  }
  if (host.startsWith('user.') || host.includes('.user.')) {
    return { variant: variants.user, basename: '/' };
  }

  const firstSeg = location.pathname.replace(/^\/+/, '').split('/')[0];
  if (firstSeg === 'control' || firstSeg === 'user') {
    return { variant: variants[firstSeg as 'control' | 'user'], basename: `/${firstSeg}` }; // path ⇒ "/control" or "/user"
  }

  const env = (process.env.REACT_APP_UI_VARIANT || 'user') as 'control' | 'user';
  return { variant: variants[env], basename: '/' };
}



(async () => {
  const { variant, basename } = await resolveVariantAndBase();
    console.log('[BOOT]', { pathname: location.pathname, basename, variant: variant.id });
  document.title = variant.title;

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <VariantContext.Provider value={variant}>
          <BrowserRouter basename={basename}>
            <App />
          </BrowserRouter>
        </VariantContext.Provider>
      </Provider>
    </React.StrictMode>
  );

  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      const w = registration.waiting;
      if (w) {
        w.addEventListener('statechange', (e: any) => {
          if (e?.target?.state === 'activated') window.location.reload();
        });
        w.postMessage({ type: 'SKIP_WAITING' });
      }
    },
  });
  reportWebVitals();
})();
